define([
	"dojo/_base/declare",
	"csi/table/New",
	"csi/xml"
], function(declare,New,xml) {

	return declare(New, {

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set value for BOM product type and make it read only
			view.addFixedValue("BOMProductType", "ProductType:Style");
			view.getField("SortOrder").m_bRequired = true;
			this.inherited(arguments);
		},

		toWriter: function() {
			this.inherited(arguments);
			this.m_writer.changeNode(this.m_urlNode)
				.changeAttribute("PlacementProductType", xml.ATTR_ENUM, "ProductType:Style")
				.changeAttribute("AdHoc", xml.ATTR_BOOLEAN, false);
		}

	});
});